import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { PropTypeShapes } from "../../types";
import RelationshipIntersectionView from "./RelationshipIntersectionView";

// import debugUtils from "../../utils/debugUtils";

const renderCols = function(
  columnData,
  columnAgeData,
  colGroups,
  selectedItemIds,
  subjectId,
  subjectType,
  onIntersectionClick,
  viewId,
  showEntityColor
) {
  return colGroups
    .map(g => {
      const colElements = g.cols.map((col, cIndex) => {
        const elementId = `intersection-${viewId}-${subjectId}-${col.id}`;

        const c = columnData.get(col.id);
        let ageLabel = null;
        if (columnAgeData && columnAgeData.size) {
          ageLabel = columnAgeData.get(col.id);
        }

        return (
          <RelationshipIntersectionView
            key={col.id}
            odd={cIndex % 2 === 0}
            left={col.left}
            firstInGroup={col.left === g.left}
            selected={selectedItemIds.indexOf(col.id) >= 0}
            subjectId={subjectId}
            subjectType={subjectType}
            itemId={col.id}
            itemType={col.type}
            relationshipValues={c}
            onClick={onIntersectionClick}
            ageLabel={ageLabel}
            viewId={viewId}
            columnColor={showEntityColor ? col.color : null}
            id={elementId}
          />
        );
      });
      return colElements;
    })
    .flatten()
    .toArray();
};

class RelationshipRowColumnView extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.onRowClick = this.onRowClick.bind(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   debugUtils.logPropChanges("RelationshipRowColumnView", this.props, nextProps, true);
  // }

  onRowClick() {
    this.props.onRowClick(this.props.id);
  }

  render() {
    let classes = ["relationshipTableRow"];
    if (this.props.selected) {
      classes.push("selected");
    }

    if (this.props.isFiltered) {
      classes.push("isFiltered");
    }

    if (this.props.index % 2) {
      classes.push("odd");
    }

    return (
      <div
        className={classes.join(" ")}
        style={{
          left: `${this.props.rect.left}px`,
          top: `${this.props.rect.top}px`,
          // transform: `translateY(${this.props.rect.top}px)`,
          height: `${this.props.rect.height}px`,
          width: `${this.props.rect.width}px`
        }}
        onClick={this.onRowClick}
      >
        {renderCols(
          this.props.columnData,
          this.props.columnAgeData,
          this.props.colGroups,
          this.props.selectedItemIds,
          this.props.id,
          this.props.type,
          this.props.onIntersectionClick,
          this.props.viewId,
          this.props.showEntityColor
        )}
        <div className="rPaddingCol" />
      </div>
    );
  }
}

RelationshipRowColumnView.propTypes = {
  viewId: PropTypes.string.isRequired,

  onIntersectionClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  index: PropTypes.number.isRequired,
  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  columnData: PropTypeShapes.relationshipIntersectionMap.isRequired,
  color: PropTypes.string.isRequired,
  rect: PropTypeShapes.flatRect.isRequired,
  showEntityColor: PropTypes.bool.isRequired,

  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  displayId: PropTypes.string.isRequired,
  isFiltered: PropTypes.bool,
  titleMetrics: PropTypeShapes.textMetrics.isRequired,
  dateTextSize: PropTypeShapes.textSize.isRequired,
  durationTextSize: PropTypeShapes.textSize.isRequired,
  narrativeTextSize: PropTypeShapes.textSize.isRequired,
  summaryMetrics: PropTypeShapes.textMetrics.isRequired,
  identifierSize: PropTypeShapes.size.isRequired,

  relationshipViewSettings: PropTypeShapes.relationshipViewSettings.isRequired,
  columnAgeData: ImmutablePropTypes.map,
  onRowClick: PropTypes.func.isRequired
};

export default RelationshipRowColumnView;
